import { handleActions } from 'redux-actions';
import { setCalendarAccount } from '../actions/calendarActions';

const defaultState = {
  calendarAccount: null,
};

export default handleActions(
  {
    [setCalendarAccount](state, action) {
      return { ...state, calendarAccount: action.payload };
    },
  },
  defaultState
);
